<template>
	<div>
		<Head title="Skapa kategori" />

		<Breadcrumbs
			href="/categories"
			:parentLabel="__('Categories')"
			:childLabel="__('Create')"
		/>

		<div class="w-full overflow-hidden bg-white rounded-md shadow">
			<CategoryForm
                :submit="store"
                label="Skapa kategori"
				:receiver_list="receiver_list"
				:all_users="all_users"
            />
		</div>
	</div>
</template>

<script>
	import { Head } 	  from '@inertiajs/inertia-vue3'
	import Layout 		  from '@/Shared/Layout'
	import Breadcrumbs 	  from '@/Shared/Breadcrumbs'
	import CategoryForm   from './Form'

	export default {
		components: {
			Head,
			Breadcrumbs,
			CategoryForm,
		},
		layout: Layout,
		remember: 'form',
        props: {
			receiver_list: Array,
			all_users: Array,
		},
		data() {
			return {
				options: [],
				categories: [],
			}
		},
		methods: {
			store(form) {
				form.post('/categories')
			}
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
